import { Button, Col, Divider, Form, Input, Modal, Row, Table, notification } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { FaEye, FaFileSignature } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import DistributionDetail from "../../Components/distribuicao/detail";
import { getDistribution, getDistributions, getFundRequest, getPlanification, getPlanifications } from "../../API/StaticGetters";
import dayJS from "dayjs";
import axios from "axios";
import { ComponentToPrint } from "../../Components/requisicao/print";
import ModeloRequisicao from "../../Components/requisicao/modelo";
import ReqDetail from "../../Components/distribuicao/requisicao";
import PlanificationDetail from "../../Components/planificacao/detail";

const Historico = () => {
    const [loading, setLoading] = useState(false);
    const [dists, setDists] = useState([]);
    const [reqs, setReqs] = useState([]);
    const [plans, setPlans] = useState([])
    const [modalView, setModalView] = useState(false);
    const [modalReq, setModalReq] = useState(false);
    const [modalPlan, setModalPlan] = useState(false);
    const [plan, setPlan] = useState({})
    const [distribution, setDistribution] = useState({});
    const [selectedMenu, setSelectedMenu] = useState('dist');
    const reqPrint = useRef()
    const [selectedReq, setSelectedReq] = useState({})


    useEffect(() => {
        localStorage.setItem('title', 'Histórico');
        localStorage.setItem('type', '2')
        getDist()
    }, [])

    const getDist = async () => {
        setLoading(true)
        try {
            let dists = await getDistributions('All')
            setDists(dists)
        } finally {
            setLoading(false)
        }
    }

    const getReq = async () => {
        setLoading(true)
        try {
            let dists = await getFundRequest('All')
            setReqs(dists)
        } finally {
            setLoading(false)
        }
    }

    const getPlans=async()=>{
        setLoading(true)
        try {
            let dists = await getPlanifications('All')
            setPlans(dists)
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            title: 'Referência',
            dataIndex: 'reference',
            key: 'reference',
            width: 150,
        },
        {
            title: 'Unidade Organica',
            dataIndex: 'unidade',
            key: 'unidade',
            render: (text, record) => (
                <p>{record.unit.name}</p>
            ),
        },
        {
            title: 'Período',
            dataIndex: 'periodo',
            key: 'periodo',
            width: 200,
            render: (text, record) => (
                <p>{record.period.name}</p>
            ),
        },
        {
            title: 'Data de Registo',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 200,
            render: (text, record) => (
                <p>{dayJS(record.created_at).format('DD/MM/YYYY HH:mm')}</p>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (text, record) => (
                <p>{record.status.name}</p>
            ),
        },
        {
            title: 'Acções',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <span className='flex justify-center items-center'>
                    <a onClick={() => handleView(record.id)}>
                        <FaEye
                            size={17}
                            color="#047d4b"
                        />
                    </a>
                </span>
            ),
        },
    ];

    const columnsReq = [
        {
            title: 'Referência',
            dataIndex: 'reference',
            key: 'reference',
            width: 150,
        },
        {
            title: 'Unidade Organica',
            dataIndex: 'unidade',
            key: 'unidade',
            render: (text, record) => (
                <p>{record?.distribution?.unit?.name}</p>
            ),
        },
        {
            title: 'Valor',
            dataIndex: 'value',
            key: 'value',
            width: 200,
            render: (text) => `MZN ${parseFloat(text).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
        },
        {
            title: 'Data de Requisição',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 200,
            render: (text, record) => (
                <p>{dayJS(record.created_at).format('DD/MM/YYYY HH:mm')}</p>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (text, record) => (
                <p>{record.status.name}</p>
            ),
        },
        {
            title: 'Acções',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <span className='flex justify-center items-center'>
                    <a onClick={() => record.status.id !== 1 ? handleViewReq(record) : null}>
                        <FaEye
                            size={17}
                            color={record.status.id !== 1 ? "#047d4b" : "gray"}
                        />
                    </a>
                </span>
            ),
        },
    ];

    const columnsPlan=[
        {
            title: 'Referência',
            dataIndex: 'reference',
            key: 'reference',
            width: 150,
        },
        {
            title: 'Unidade Organica',
            dataIndex: 'unidade',
            key: 'unidade',
            render: (text, record) => (
                <p>{record?.unit?.name}</p>
            ),
        },
        {
            title: 'Valor total',
            dataIndex: 'plan',
            key: 'value',
            width: 200,
            render: (text, record) => (
                <p>{`MZN ${record.plan.reduce((acc, item) => acc + parseFloat(item.value), 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`}</p>
            )
        },
        {
            title: 'Data de Registo',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 200,
            render: (text, record) => (
                <p>{dayJS(record.created_at).format('DD/MM/YYYY HH:mm')}</p>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (text, record) => (
                <p>{record.status.name}</p>
            ),
        },
        {
            title: 'Acções',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <span className='flex justify-center items-center'>
                    <a onClick={() => handleViewPlan(record)}>
                        <FaEye
                            size={17}
                            color={"#047d4b"}
                        />
                    </a>
                </span>
            ),
        },
    ];

    const handleView = async (id) => {
        let dados = await getDistribution(id)
        setDistribution(dados)
        setModalView(true)
    }

    const handleViewReq = (record) => {
        setSelectedReq(record)
        setModalReq(true)
    }

    const handleViewPlan =async (record) => {
        let dados= await getPlanification(record.id)
        setPlan(dados)
        setModalPlan(true)
    }

    const handleMenu = (menu) => {
        if (menu === 'dist') {
            setSelectedMenu('dist')
            getDist()
        } else if (menu === 'req') {
            setSelectedMenu('req')
            getReq()
        } else if (menu === 'plan') {
            setSelectedMenu('plan')
            getPlans()
        }
    }

    return (
        <div className='w-full flex flex-col px-5 py-4'>
            <p className="title-form">Histórico</p>
            <div className='menu-bar mt-2'>
                <div className={`menu-bar-item ${selectedMenu === 'dist' ? 'active' : ''}`} onClick={() => handleMenu('dist')}>
                    <p className='menu-bar-item-text'>Distribuições</p>
                </div>
                <div className={`menu-bar-item ${selectedMenu === 'req' ? 'active' : ''}`} onClick={() => handleMenu('req')}>
                    <p className='menu-bar-item-text'>Requisições de Fundos</p>
                </div>
                <div className={`menu-bar-item ${selectedMenu === 'plan' ? 'active' : ''}`} onClick={() => handleMenu('plan')}>
                    <p className='menu-bar-item-text'>Planificações</p>
                </div>
            </div>
            {selectedMenu === 'dist' && <>
                <Table
                    className='custom-table'
                    size="small"
                    columns={columns}
                    dataSource={dists}
                    loading={loading}
                    pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '50', '100'] }}
                    locale={{
                        emptyText: 'Sem distribuições'
                    }}
                />
            </>}
            {selectedMenu === 'req' && <>
                <Table
                    className='custom-table'
                    size="small"
                    columns={columnsReq}
                    dataSource={reqs}
                    loading={loading}
                    pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '50', '100'] }}
                    locale={{
                        emptyText: 'Sem requisições de fundos'
                    }}
                />
            </>}
            {selectedMenu === 'plan' && <>
                <Table
                    className='custom-table'
                    size="small"
                    columns={columnsPlan}
                    dataSource={plans}
                    loading={loading}
                    pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '50', '100'] }}
                    locale={{
                        emptyText: 'Sem planificações'
                    }}
                />
            </>}
            <Modal
                title={<p className='title'>DETALHES DA DISTRIBUIÇÃO</p>}
                open={modalView}
                onOk={() => setModalView(false)}
                onCancel={() => setModalView(false)}
                footer={null}
                width={700}
            >
                <DistributionDetail dados={distribution} />
            </Modal>
            <Modal
                title={<p className='title'>REQUISIÇÃO DE FUNDOS</p>}
                open={modalReq}
                onOk={() => setModalReq(false)}
                onCancel={() => setModalReq(false)}
                footer={null}
                width={600}
            >
                <ReqDetail dados={selectedReq} />
            </Modal>
            <Modal
                title={<p className='title'>DETALHES DA PLANIFICAÇÃO</p>}
                open={modalPlan}
                onOk={() => setModalPlan(false)}
                onCancel={() => setModalPlan(false)}
                footer={null}
                width={700}
            >
                <PlanificationDetail dados={plan} />
            </Modal>
        </div>
    )
}

export default Historico;